import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import CommonLayout from '../layouts/commonLayout';
import GoButton from './GoButton';
import { localize, DICTIONARY_KEYS } from '../localization';
import { markFirstUserInteraction } from '../userInteraction/userInteractionActions';

/**
 * Overlay for AR users who refresh mid-assessment.
 * Captures gesture needed to unlock iOS audio.
 */
const ARGestureOverlay = ({ onGestureCaptured }) => {
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(markFirstUserInteraction());
        onGestureCaptured();
    };

    return (
        <CommonLayout class="start">
            <div className="container">
                <GoButton
                    ariaLabel={localize(DICTIONARY_KEYS.RESUME)}
                    text={localize(DICTIONARY_KEYS.RESUME)}
                    onClick={handleClick}
                />
            </div>
        </CommonLayout>
    );
};

ARGestureOverlay.propTypes = {
    onGestureCaptured: PropTypes.func.isRequired,
};

export default ARGestureOverlay;
